// =============================================================================
// DOM MANIPULATION UTILITIES
// =============================================================================

import constants from '../constants';
import Cookie from 'js-cookie';
import { CookieKeys } from '../pedigree-constants';

export function addPedigreeEventListeners(self) {
  window.addEventListener('message', async (event) => {
    // patient web portal print event listener
    if (event.data === 'web-pedigree-iframe-print') {
      self.patientPedigreePrint(event);
    }
    else if (event.data === 'mobile-pedigree-iframe-print') {
      const isMobile = true
      self.patientPedigreePrint(event, isMobile);
    }
    // patient web portal reload event listener
    else if (event.data === 'web-reload-pedigree') {
      self.setState({ loading_patient_pedigree: true });
      await self.props.fetchProbandTree();
      await self.reRenderPedigree();
      self.setState({ loading_patient_pedigree: false });
    }
  })

  // patient app print event listener
  window.addEventListener("mobile-print", (e) => {
    self.prepareForPrint(true, true);
  }, false)

  // patient app reload event listener
  window.addEventListener("mobile-pedigree-reload", async (e) => {
    self.setState({ loading_patient_pedigree: true });
    await self.props.fetchProbandTree();
    await self.reRenderPedigree();
    self.setState({ loading_patient_pedigree: false });
  }, false)


  window.addEventListener("resize", self.resizePedigree);
  window.print = self;
  self.overflow = document.body.style.overflow;
  document.body.style.overflow = "hidden";
  self.setCookie(CookieKeys.SIDEBAR_SHOW_MORE, false);
}

export function addPedigreeHandleEventListeners(self) {
  let all_pedigree_handles = document.querySelectorAll('.pedigree-handle');

  console.log(all_pedigree_handles)

  console.log(self.pedigreeHandleMouseOverHandler)

  for (let handle of all_pedigree_handles) {
    handle.addEventListener('mouseover', self.pedigreeHandleMouseOverHandler);

    handle.addEventListener('mouseout', self.pedigreeHandleMouseOutHandler);
  }

  if (self.render_patient_pedigree) {
    self.handleToggleLegend(false);
  }
}

/**
 * Remove unnecessary elements from DOM
 */
export function removeUnNecessaryElementsFromDOM(self) {

  window.removeEventListener("resize", self.resizePedigree);

  let consanguineous_tooltip = document.querySelectorAll('#consanguineous-tooltip');
  for (let i = consanguineous_tooltip.length; i--;) {
    consanguineous_tooltip[i].style.visibility = 'hidden';
  }

  let reassign_parents_tooltip = document.querySelectorAll('#re-assign-parents-tooltip');
  for (let i = reassign_parents_tooltip.length; i--;) {
    reassign_parents_tooltip[i].style.visibility = 'hidden';
  }
  window.removeEventListener('mousemove', self.consanguineousToolTipTrack, false);
  window.removeEventListener('mousemove', self.reAssignParentsToolTipTrack, false);
  window.removeEventListener('mousemove', self.donorAssignToolTipTrack, false);

  document.body.style.overflow = self.overflow;
  document.body.style.overflow = "visible";

  let legend_container = document.getElementById(constants.LEGEND_DOM_CONTAINER_ELEMENT);
  if (legend_container){
    legend_container.remove();
    legend_container = null;
  }

  let archive_table_container = document.getElementById(constants.ARCHIVE_DATA_TABLE);
  if(archive_table_container){
    archive_table_container.remove();
    archive_table_container = null;
  }

  let pedigree_container = document.getElementById("pedigree-container");
  if (pedigree_container) {
    pedigree_container.remove();
    pedigree_container = null;
  }

  let all_pedigree_handles = document.querySelectorAll('.pedigree-handle');

  for (let handle of all_pedigree_handles) {
    handle.removeEventListener('mouseover', self.pedigreeHandleMouseOverHandler);

    handle.removeEventListener('mouseout', self.pedigreeHandleMouseOutHandler);
  }
}

/**
 * Check if legend exists on DOM
 */
export function legendExistsOnDom() {
  let existsOnDom = false;
  let displayLegend = Cookie.get(CookieKeys.PEDIGREE_LEGEND);
  let displayPedigreeNotes = Cookie.get(CookieKeys.PEDIGREE_LEGEND_NOTES);
  if (displayPedigreeNotes === 'true' || displayLegend === 'true') existsOnDom = true;
  return existsOnDom;
}

/**
 * Setup pedigree handle event listeners
 */
export function setupPedigreeHandleListeners(mouseOverHandler, mouseOutHandler) {
  let all_pedigree_handles = document.querySelectorAll('.pedigree-handle');

  for (let handle of all_pedigree_handles) {
    handle.addEventListener('mouseover', mouseOverHandler);
    handle.addEventListener('mouseout', mouseOutHandler);
  }
}

/**
 * Remove pedigree handle event listeners
 */
export function removePedigreeHandleListeners(mouseOverHandler, mouseOutHandler) {
  let all_pedigree_handles = document.querySelectorAll('.pedigree-handle');

  for (let handle of all_pedigree_handles) {
    handle.removeEventListener('mouseover', mouseOverHandler);
    handle.removeEventListener('mouseout', mouseOutHandler);
  }
}